import { useLoyalty } from "@chef/state-management/hooks";
import { CalendarQuery } from "@chef/state-management";
import { getBasketForCalendarWeek } from "@chef/state-management/helpers";
import { DeliveryFee } from "../shared/DeliveryFee";

interface CalendarWeekDeliveryProps {
  calendarWeek: CalendarQuery["calendar"][number];
}

export const CalendarWeekDeliveryFee = ({
  calendarWeek,
}: CalendarWeekDeliveryProps) => {
  const { data: loyaltyData } = useLoyalty();

  const basketFromCalendar = getBasketForCalendarWeek({ calendarWeek });
  const feeFromCalendar =
    basketFromCalendar.mealboxBasket?.shippingDetails.plannedDeliveryInformation
      .customerFee;
  const customerFee = feeFromCalendar || 0;

  if (!loyaltyData) {
    return null;
  }

  return (
    <DeliveryFee
      customerFee={customerFee}
      hasFreeShipping={loyaltyData.currentLevel === 4}
    />
  );
};
